import { render, staticRenderFns } from "./ques122.vue?vue&type=template&id=5d147cc9"
import script from "./ques122.vue?vue&type=script&lang=js"
export * from "./ques122.vue?vue&type=script&lang=js"
import style0 from "./ques122.vue?vue&type=style&index=0&id=5d147cc9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports